






import { Component, Vue } from 'vue-property-decorator'
import AppTodoList from './features/app-todo-list.vue'
import AppLocationList from './features/app-location-list.vue'
import AppCreateTodo from './features/app-create-todo.vue'

@Component({
  components: {
    AppLocationList,
    AppTodoList,
    AppCreateTodo
  }
})
export default class App extends Vue {}
